"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentValues = void 0;
var EnvironmentValues = /** @class */ (function () {
    function EnvironmentValues(environmentName, serviceOffering, serviceLine, service, componentName, componentId, ictoId, randomizationUnitId, assignmentContext, experimentId) {
        this.EnvironmetName = environmentName;
        this.ServiceOffering = serviceOffering;
        this.ServiceLine = serviceLine;
        this.Service = service;
        this.ComponentName = componentName;
        this.ComponentId = componentId;
        this.IctoId = ictoId;
        this.RandomizationUnitId = randomizationUnitId;
        this.AssignmentContext = assignmentContext;
        this.ExperimentId = experimentId;
    }
    return EnvironmentValues;
}());
exports.EnvironmentValues = EnvironmentValues;
//# sourceMappingURL=EnvironmentValues.js.map